/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ConfigurationTable_ConfigurationFragmentDoc } from '../ConfigurationsTable/__generated__/ConfigurationsTable.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type DuplicateDisplayConfigurationMutationVariables = Types.Exact<{
  configurationId: Types.Scalars['String'];
  name: Types.Scalars['String'];
  description?: Types.InputMaybe<Types.Scalars['String']>;
  customerId: Types.Scalars['String'];
}>;


export type DuplicateDisplayConfigurationMutation = { __typename: 'Mutation', cloneDisplayConfiguration: { __typename: 'CloneConfigurationPayload', configuration: { __typename: 'ConfigurationModel', id: string, customerId: string, platform: string, name: string, state: Types.ConfigurationStatus, description?: string | null, createdAt: any, version: number, draft?: { __typename: 'ConfigurationModel', id: string, name: string, description?: string | null, state: Types.ConfigurationStatus, platform: string } | null } } };


export const DuplicateDisplayConfigurationDocument = gql`
    mutation DuplicateDisplayConfiguration($configurationId: String!, $name: String!, $description: String, $customerId: String!) {
  cloneDisplayConfiguration(
    configurationId: $configurationId
    name: $name
    description: $description
    customerId: $customerId
  ) {
    configuration {
      ...ConfigurationTable_configuration
    }
  }
}
    ${ConfigurationTable_ConfigurationFragmentDoc}`;
export type DuplicateDisplayConfigurationMutationFn = ApolloReactCommon.MutationFunction<DuplicateDisplayConfigurationMutation, DuplicateDisplayConfigurationMutationVariables>;

/**
 * __useDuplicateDisplayConfigurationMutation__
 *
 * To run a mutation, you first call `useDuplicateDisplayConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateDisplayConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateDisplayConfigurationMutation, { data, loading, error }] = useDuplicateDisplayConfigurationMutation({
 *   variables: {
 *      configurationId: // value for 'configurationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useDuplicateDisplayConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DuplicateDisplayConfigurationMutation, DuplicateDisplayConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DuplicateDisplayConfigurationMutation, DuplicateDisplayConfigurationMutationVariables>(DuplicateDisplayConfigurationDocument, options);
      }
export type DuplicateDisplayConfigurationMutationHookResult = ReturnType<typeof useDuplicateDisplayConfigurationMutation>;
export type DuplicateDisplayConfigurationMutationResult = ApolloReactCommon.MutationResult<DuplicateDisplayConfigurationMutation>;
export type DuplicateDisplayConfigurationMutationOptions = ApolloReactCommon.BaseMutationOptions<DuplicateDisplayConfigurationMutation, DuplicateDisplayConfigurationMutationVariables>;